import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var GridCol = styled.div.withConfig({
  displayName: "GridCol",
  componentId: "sc-18wg4lw-0"
})(["position:relative;flex:0 1 ", "%;padding:0 12px;margin-left:", "%;text-align:", ";img{max-width:100%;}", ";"], function (props) {
  return 100 * props.cols / 12;
}, function (props) {
  return 100 * props.offset / 12;
}, function (props) {
  return props.textAlign;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: 0;\n    margin-right: 0;\n    ", ";\n    text-align: left;\n  "])), function (props) {
  return !props.disableStackMargin && "\n      margin-top: 20px;\n      margin-bottom: 20px;\n    ";
}));
GridCol.defaultProps = {
  cols: 12,
  offset: 0,
  textAlign: 'left'
};
export default GridCol;